const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];

String.prototype.toPersianDigits = function() {
  return this.replace(/[0-9]/g, w => {
    return persianDigits[+w];
  });
};

const centimeterToPixel = cmValue => cmValue * 37.7952755905511;

const millimeterToPixel = mmValue => mmValue * 3.779527559055;

const inchToPixel = inValue => inValue * 96;

export { centimeterToPixel, millimeterToPixel, inchToPixel };
